import * as React from 'react';
import './badge.css';

/**
 * Badge (CC10): one kicker recipe - 11px, 800, uppercase, 0.14em tracking.
 *   default  teal-700 on teal-50 (also the 'success' alias)
 *   amber    amber-700 on amber-50 (also the 'warning' alias)
 *   neutral  gray-600 on gray-100 (also the 'outline' alias)
 */
type Variant = 'default' | 'amber' | 'neutral' | 'outline' | 'success' | 'warning';

const VARIANT_CLASS: Record<Variant, string> = {
  default: 'teal',
  success: 'teal',
  amber: 'amber',
  warning: 'amber',
  neutral: 'neutral',
  outline: 'neutral',
};

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  children: React.ReactNode;
  variant?: Variant;
  className?: string;
};

/** Every other span attribute (aria-label, title, data-tour, id, style,
 *  onClick) is forwarded to the element (PP-req-02). */
export function Badge({ children, variant = 'default', className = '', ...rest }: BadgeProps) {
  return (
    <span
      {...rest}
      className={`lnr-badge lnr-badge--${VARIANT_CLASS[variant]} ${className}`.trim()}
    >
      {children}
    </span>
  );
}
